import PropTypes from 'prop-types';
import { Box, Chip, Tooltip, Typography } from '@mui/material';

import { patientAddressLines } from 'common/utils/formatPatientAddress';

const FillLaterAddressCell = ({ address, addressDirectoryId }) => {
  const [street, locality] = patientAddressLines(address);

  if (!street && !locality) return <Box component='span'>&mdash;</Box>;

  return (
    <Box sx={{ minWidth: 0 }}>
      <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
        <Box component='span'>{street || locality}</Box>
        {addressDirectoryId && (
          <Tooltip title='Different from the original order' arrow>
            <Chip
              size='small'
              variant='outlined'
              color='info'
              label='Changed'
              sx={{
                height: 16,
                fontWeight: 600,
                '& .MuiChip-label': { px: 0.6, fontSize: '0.6rem' },
              }}
            />
          </Tooltip>
        )}
      </Box>
      {street && locality && (
        <Typography variant='caption' color='textSecondary' display='block'>
          {locality}
        </Typography>
      )}
    </Box>
  );
};

FillLaterAddressCell.propTypes = {
  address: PropTypes.shape({
    line1: PropTypes.string,
    line2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string,
  }),
  addressDirectoryId: PropTypes.string,
};

FillLaterAddressCell.defaultProps = {
  address: null,
  addressDirectoryId: null,
};

export default FillLaterAddressCell;
